import axios from "axios";

const portalApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

portalApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("fl_portal_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

portalApi.interceptors.response.use(
  (res) => res,
  (error) => {
    const d = error?.response?.data;
    if (d && Array.isArray(d.detail)) {
      d.detail = d.detail
        .map((it) => (it && typeof it.msg === "string" ? it.msg : JSON.stringify(it)))
        .join(" ");
    }
    return Promise.reject(error);
  },
);

export function portalFileUrl(path) {
  const t = localStorage.getItem("fl_portal_token") || "";
  return `${process.env.REACT_APP_BACKEND_URL}/api/portal/files/view?path=${encodeURIComponent(path)}&auth=${encodeURIComponent(t)}`;
}

export default portalApi;
